import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BONUS_VALUE, bonuses } from '../data/finanza';
export function Bonuses() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-36" data-mp="pjg5q15wl80x">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-12" data-id="element-37" data-mp="avuzvzhn8upb">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-4" data-id="element-38" data-mp="ftwlar2jl63y">
          <p className="font-serif text-2xl italic leading-none text-[#1F9D6B]" data-id="element-39" data-mp="fs3d37ca6dtu">Ma non è tutto!</p>
          <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-[#1E2B58] sm:text-6xl" data-id="element-40" data-mp="1whr791cga5n">
            5 bonus <em className="text-[#1F9D6B]" data-id="element-41" data-mp="3o1lgkv13brl1">senza costi aggiuntivi</em>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-[#1E2B58]/75" data-id="element-42" data-mp="3o3y4rpxfyy6j">
            Cinque risorse extra incluse insieme ai tuoi sei volumi – per il mercatino, l'inizio
            della lezione, le famiglie, l'aula e il supplente.
          </p>
        </div>

        <ol className="border-t border-[#1E2B58]/15 lg:col-span-8" data-id="element-43" data-mp="1r80f9x94qu90">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="grid grid-cols-[2.5rem_1fr] gap-x-5 border-b border-[#1E2B58]/15 py-9 sm:grid-cols-[3.5rem_1fr] sm:gap-x-8" data-id="element-44" data-mp="3id54555371a9" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-[#1F9D6B] sm:text-6xl" aria-hidden="true" data-id="element-45" data-mp="3r6i6sysydh9j">
                {index + 1}
              </span>
              <div data-id="element-46" data-mp="3n79dfv1trlei">
                <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3" data-id="element-47" data-mp="2zfkg20a5c6qp">
                  <h3 className="max-w-md font-serif text-2xl leading-tight text-[#1E2B58] sm:text-3xl" data-id="element-48" data-mp="2zheztb9olst7">
                    <span className="sr-only" data-id="element-49" data-mp="38g8vmzf6uf5p">Bonus {index + 1} – </span>
                    {bonus.title}
                  </h3>
                  <span className="flex shrink-0 items-center gap-2" data-id="element-50" data-mp="33gw6u94ray0h">
                    <span className="text-sm text-[#1E2B58]/50" data-id="element-51" data-mp="nq1aewy3yyrd">
                      Valore <s data-id="element-52" data-mp="ns4bcc0sucav">{BONUS_VALUE}</s>
                    </span>
                    <span className="-rotate-3 rounded border-2 border-[#1F9D6B] px-2 py-0.5 text-xs font-bold uppercase tracking-widest text-[#1F9D6B]" data-id="element-53" data-mp="ipww9dkoag4b">
                      Incluso
                    </span>
                  </span>
                </div>
                <p className="mt-3 max-w-xl leading-relaxed text-[#1E2B58]/75" data-id="element-54" data-mp="3ljl41h2o9dug">{bonus.text}</p>
                <ul className="mt-4 grid max-w-xl gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-55" data-mp="3qipdm8tiddlb">
                  {bonus.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-[#1E2B58]/75" data-id="element-56" data-mp="2tsoscjsclf8r">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#1F9D6B]" strokeWidth={2.5} aria-hidden="true" data-id="element-57" data-mp="2xtqt551wxzcu" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-4 max-w-xl font-serif text-lg italic leading-snug text-[#1F9D6B]" data-id="element-58" data-mp="37jjttb0iou2b">
                  {bonus.benefit}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}